import { Icon } from "../Icon.jsx";

const WORKSPACE_TABS = [
  {
    id: "PENDING",
    icon: "document",
    label: "Perlu Diproses",
    description: "Belum lengkap, sebagian dibuat, atau perlu tindak lanjut",
  },
  {
    id: "COMPLETED",
    icon: "check",
    label: "DO Lengkap",
    description: "Seluruh Delivery Order tersedia",
  },
  {
    id: "CANCELLED",
    icon: "close",
    label: "Dibatalkan",
    description: "Fleet Order yang sudah dibatalkan",
  },
];

export function DoPreparationsCommandHeader({
  contextLabel,
  loading,
  onRefresh,
  totalCount,
  updatedAt,
}) {
  return (
    <header className="do-command-header">
      <div className="do-command-header__identity">
        <span className="do-command-header__eyebrow">Kontrol Dokumen</span>
        <div className="do-command-header__title-row">
          <h1>Pembuatan DO</h1>
          <span className="do-command-header__context">{contextLabel}</span>
        </div>
        <p>
          Persiapkan Delivery Order berdasarkan Fleet Order dan status terbaru
          Accurate.
        </p>
      </div>

      <div className="do-command-header__system" aria-label="Status data Pembuatan DO">
        <span className="do-command-header__system-icon" aria-hidden="true">
          <Icon name="database" size={18} />
        </span>
        <div>
          <span>Terakhir diperbarui</span>
          <strong>{updatedAt || "Belum pernah"}</strong>
          <small>Data operasional Pembuatan DO</small>
        </div>
        <div className="do-command-header__count">
          <span>Ditampilkan</span>
          <strong>{totalCount}</strong>
          <small>Fleet Order</small>
        </div>
      </div>

      <div className="do-command-header__actions">
        <button
          className="primary-button do-command-header__primary-action"
          disabled={loading}
          onClick={onRefresh}
          type="button"
        >
          <Icon name="refresh" size={16} />
          {loading ? "Memuat…" : "Perbarui daftar"}
        </button>
      </div>
    </header>
  );
}

export function DoPreparationsWorkspaceTabs({ activeTab, counts, onChange }) {
  return (
    <div className="do-workspace-tabs" aria-label="Konteks Pembuatan DO" role="tablist">
      {WORKSPACE_TABS.map((tab) => {
        const active = activeTab === tab.id;

        return (
          <button
            aria-selected={active}
            className={active ? "is-active" : ""}
            key={tab.id}
            onClick={() => onChange(tab.id)}
            role="tab"
            tabIndex={active ? 0 : -1}
            type="button"
          >
            <span className="do-workspace-tabs__icon" aria-hidden="true">
              <Icon name={tab.icon} size={17} />
            </span>
            <span className="do-workspace-tabs__copy">
              <span>
                <strong>{tab.label}</strong>
                <em>{counts?.[tab.id] ?? 0}</em>
              </span>
              <small>{tab.description}</small>
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function DoPreparationsKpiStrip({ children }) {
  return (
    <section aria-label="Ringkasan tindak lanjut Pembuatan DO" className="do-kpi-section">
      <header className="do-kpi-section__header">
        <span>
          <Icon name="database" size={13} />
          Ringkasan tindak lanjut
        </span>
        <small>Prioritas berdasarkan seluruh Fleet Order operasional</small>
      </header>
      <div className="do-kpi-grid">{children}</div>
    </section>
  );
}

export function DoKpiCard({ detail, icon, label, tone = "neutral", value }) {
  return (
    <article className={`do-kpi-card do-kpi-card--${tone}`}>
      <span className="do-kpi-card__icon" aria-hidden="true">
        <Icon name={icon} size={17} />
      </span>
      <div>
        <span>{label}</span>
        <strong>{value}</strong>
        <small>{detail}</small>
      </div>
    </article>
  );
}

export function DoPreparationsFilterWorkbench({ activeFilters, children }) {
  return (
    <section className="do-filter-workbench" aria-label="Filter Pembuatan DO">
      <header className="do-filter-workbench__heading">
        <div>
          <span className="do-filter-workbench__icon" aria-hidden="true">
            <Icon name="filter" size={15} />
          </span>
          <div>
            <strong>Filter Pembuatan DO</strong>
            <span>Cari dokumen, lalu prioritaskan depot, driver, status proses, rute, atau tanggal berangkat.</span>
          </div>
        </div>
      </header>
      {children}
      {activeFilters}
    </section>
  );
}

export function DoActiveFilterSummary({ contextLabel, labels }) {
  return (
    <div className="do-active-filters" aria-live="polite">
      <span className="do-active-filters__label">Filter aktif</span>
      <div className="do-active-filters__chips">
        <span className="is-neutral">Konteks: {contextLabel}</span>
        {labels.map((label) => (
          <span key={label}>{label}</span>
        ))}
      </div>
    </div>
  );
}

export function DoPreparationsListHeader({ description, title }) {
  return (
    <header className="do-data-surface__header">
      <div>
        <span className="do-data-surface__eyebrow">Daftar Operasional</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      <span className="do-data-surface__context">
        Data sesuai filter aktif
      </span>
    </header>
  );
}
